export default () => {
	const searchOpenBtn = document.querySelector('.js-mobile-search-open');
	const searchCloseBtn = document.querySelector('.js-mobile-search-close');
	const burgerBtn = document.querySelector('.js-mobile-navigation-button');
	const panel = document.querySelector('.js-mobile-search-panel');

	const desktopInput = document.querySelector('.js-search-input-desktop');
	const dropDown = document.querySelector('.js-search-dropdown');

	desktopInput?.addEventListener('mouseenter', (e) => {
		openDropDown();
		desktopInput.focus();
	});

	dropDown?.addEventListener('mouseleave', (e) => {
		closeDropDown();
	});

	document.addEventListener('nav-open', () => {
		closeDropDown();
	});

	document.addEventListener('close-search', () => {
		closeDropDown();
		closeSearch();
	});

	function openDropDown() {
		dropDown.setAttribute('aria-expanded', 'true');
		document.body.classList.add('freeze-viewport');
	}

	function closeDropDown() {
		dropDown.setAttribute('aria-expanded', 'false');
		document.body.classList.remove('freeze-viewport');
	}

	function openSearch() {
		document.body.classList.add('freeze-viewport');
		searchCloseBtn.removeAttribute('aria-hidden');
		burgerBtn.setAttribute('aria-hidden', 'true');
		panel.setAttribute('aria-expanded', 'true');
		document.dispatchEvent(new CustomEvent('mobile-search-state', { detail: { open: true } }));
	}

	function closeSearch() {
		document.body.classList.remove('freeze-viewport');
		searchCloseBtn.setAttribute('aria-hidden', 'true');
		burgerBtn.removeAttribute('aria-hidden');
		panel.removeAttribute('aria-expanded');
		document.dispatchEvent(new CustomEvent('mobile-search-state', { detail: { open: false } }));
		document.dispatchEvent(new CustomEvent('clear-search'));
	}

	if (searchOpenBtn) {
		searchOpenBtn.addEventListener('click', () => {
			openSearch();
		});
	}

	if (searchCloseBtn) {
		searchCloseBtn.addEventListener('click', () => {
			closeSearch();
		});
	}
}

class PredictiveSearch extends HTMLElement {
	constructor() {
		super();
		this.inputs = document.querySelectorAll('.js-search-input');
		this.parent = this.closest('.js-search-block');
		this.default = this.parent.querySelector('.js-search-default');
		this.results = this.parent.querySelector('.js-search-results');
		this.predictiveSearch = this.querySelector('#predictive-search');

		this.inputs.forEach((input) => {
			input.addEventListener('input', this.debounce((event) => {
				this.onChange(event);
			}, 300).bind(this));
		});

		document.addEventListener('clear-search', () => {
			this.inputs.forEach((input) => {
				input.value = '';
			});

			this.showDefault();
		});
	}

	debounce(func, timeout = 300) {
		let timer;
		return (...args) => {
			clearTimeout(timer);
			timer = setTimeout(() => { func.apply(this, args); }, timeout);
		};
	}

	onChange(evt) {
		const searchTerm = evt.target.value;

		if (searchTerm === '') {
			this.showDefault();
			return;
		}

		this.getSearchResults(searchTerm);
	}

	initCards() {
		let cards = this.querySelectorAll('.card');

		cards.forEach(function(card) {
			window.initCard(card);
		});
	}

	getSearchResults(searchTerm) {
		fetch(Shopify.routes.root + `search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=9&section_id=predictive-search`)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.showDefault();
					throw error;
				}

				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
				this.predictiveSearch.innerHTML = resultsMarkup;
				this.resultSpan = this.querySelector('#result-span');
				this.resultSpan ? this.resultSpan.innerHTML = searchTerm : false;
				this.showResults();
				this.initCards();
			})

			.catch((error) => {
				this.showDefault();
				throw error;
			});
	}

	showResults() {
		this.default.setAttribute('aria-hidden', 'true');
		this.results.setAttribute('aria-hidden', 'false');
	}

	showDefault() {
		this.default.setAttribute('aria-hidden', 'false');
		this.results.setAttribute('aria-hidden', 'true');
	}
}

class CloseSearch extends HTMLElement {
	constructor() {
		super();
		this.btn = this.querySelector('.js-search-close');

		this.btn.addEventListener('click', (e) => {
			document.dispatchEvent(new CustomEvent('close-search'));
		});
	}
}

customElements.define('predictive-search', PredictiveSearch);
customElements.define('close-search', CloseSearch);